import { useCallback } from 'react';
import getValidateFn from 'js/utils/Validation';
import { type FieldMetaState } from 'react-final-form';
import { TValidationMethod, TValidationMethodResult } from 'js/utils/Validation/types';

import { useValidationConfig } from '../../../hooks';

export const useWithRecordLevelValidation = ({ fieldName }: { fieldName: string }) => {
    const validationConfig = useValidationConfig();
    const getRecordLevelValidation = useCallback((values: Record<string, any>): Promise<Record<string, string> | null> => {
        const recordLevelValidate = getValidateFn({ validationConfig: { [fieldName]: validationConfig[fieldName] } });

        return recordLevelValidate(values);
    }, [fieldName, validationConfig]);

    return useCallback((fieldLevelValidate: TValidationMethod) => async (
        value: string = '',
        values: Record<string, any>,
        meta?: FieldMetaState<string>
    ): Promise<TValidationMethodResult> => {
        // 'Field level' validation should be run after 'Record level' one
        const recordLevelValidation = await getRecordLevelValidation(values);

        if (recordLevelValidation) {
            return recordLevelValidation[fieldName];
        }

        return fieldLevelValidate(value, values, meta);
    }, [getRecordLevelValidation, fieldName]);
};
